import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import SubstanceRelativeContextsList from './SubstanceRelativeContextsList';
import ReactionsRelativeContextsList from './ReactionsRelativeContextsList';
import CitationsRelativeContextsList from './CitationsRelativeContextsList';
import TargetsRelativeContextsList from './TargetsRelativeContextsList';

import './AvailableRelativeContextsList.scss';

function AvailableRelativeContextsList (props) {
  const {
    isTgitemsContext,
    isReactionsContext,
    isCitationsContext,
    isSubstancesContext,
    availableRelativeContext,
  } = props;

  if (!availableRelativeContext) {
    return null;
  }


  return (
    <div className='result-toolbar-available-relative-contexts-list'>
      {isSubstancesContext && <SubstanceRelativeContextsList {...props} />}
      {isReactionsContext && <ReactionsRelativeContextsList {...props} />}
      {isCitationsContext && <CitationsRelativeContextsList {...props} />}
      {isTgitemsContext && <TargetsRelativeContextsList {...props} />}
    </div>
  );
}

AvailableRelativeContextsList.propTypes = {
  isTgitemsContext: PropTypes.bool.isRequired,
  isReactionsContext: PropTypes.bool.isRequired,
  isCitationsContext: PropTypes.bool.isRequired,
  isSubstancesContext: PropTypes.bool.isRequired,
  availableRelativeContext: PropTypes.instanceOf(Map),
};

export default AvailableRelativeContextsList;

